import React, { Component, Fragment } from "react";
import themes from "../../themes";
import RoundButton from "../../components/RoundButton";
import HalfButton from "../../components/HalfButton";
import { Route, Link } from "react-router-dom";
import { BLOCK_TYPES, INLINE_STYLES, COLORS, colorStyleMap } from  "../../draftUtilities"

const EditorToolbar = props => {
  const { match, theme, saveText } = props;
  return (
    <div>
      <RoundButton
        style={{ position: "absolute", right: "8px", top: "143px" }}
        theme={theme}
        onClick={() =>
          saveText(
            match.params.book,
            match.params.chapter,
            match.params.section
          )
        }
      >
        Save
      </RoundButton>
      <RoundButton
        style={{ position: "absolute", right: "8px", top: "200px" }}
        theme={theme}
      >
        Else
      </RoundButton>
      <BlockStyleControls
                onToggle={props.toggleBlockType}
                editorState={props.editorState}
                />
      <InlineStyleControls
              onToggle={props.toggleInlineStyle}
              editorState={props.editorState}
      />
      <ColorControls 
              toggleColor={props.toggleColor}
              editorState={props.editorState} />
    </div>
  );
};
export default EditorToolbar;


const BlockStyleControls = (props) => {

  const {editorState} = props
  const selection = editorState.getSelection()
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div style={{position: "relative", top: "350px"}}>
      {BLOCK_TYPES.map((type) => 
        <StyleButton
          style={type.style}
          label={type.label}
          key={type.label}
          active={type.style === blockType}
          onToggle={props.onToggle}
        />
      )}
    </div>
  );
};

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div style={{position: "relative", top: "360px"}}>
      {INLINE_STYLES.map(type => 
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          buttonStyle={type.style}
        />
      )}
    </div>
  );
};

const ColorControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div style={{color: "white", zIndex: "3"}}>
      {COLORS.map(type => 
        <div
          onClick={() => props.toggleColor(type.style)}
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.toggleColor}
        > {type.style} </div>
      )}
    </div>
  );
};

class StyleButton extends React.Component {
 
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {

    let IMAGE = null
    if (this.props.label === 'Bold') {
      IMAGE = <i className="material-icons">format_bold</i>
    }
    else if (this.props.label === 'Italic') {
      IMAGE = <i className="material-icons">format_italic</i>
    }
    else if (this.props.label === 'Underline') {
      IMAGE = <i className="material-icons">format_underlined</i>
    }
    else if (this.props.label === 'H1') {
      IMAGE = <div className="headerSize"><i className="material-icons">format_size</i>1</div>
    }
    else if (this.props.label === 'H2') {
      IMAGE = <div className="headerSize"><i className="material-icons">format_size</i>2</div>
    }
    else if (this.props.label === 'H3') {
      IMAGE = <div className="headerSize"><i className="material-icons">format_size</i>3</div>
    }
    else if (this.props.label === 'H4') {
      IMAGE = <div className="headerSize"><i className="material-icons">format_size</i>4</div>
    }
    else if (this.props.label === 'Blockquote') {
      IMAGE = <i className="material-icons">format_quote</i>
    }
    else if (this.props.label === 'UL') {
      IMAGE = <i className="material-icons">format_list_bulleted</i>
    }
    else if (this.props.label === 'OL') {
      IMAGE = <i className="material-icons">format_list_numbered</i>
    }
    return (
      <div onClick={this.onToggle} style={{':hover': {cursor: "pointer"}}}>
      {IMAGE}
      </div>
    );
  }
}


// <HalfButton
//         style={{
//           position: "absolute",
//           right: "20px",
//           top: "290px",
//           transform: "rotate(270deg)"
//         }}
//         theme={theme}
//       >
//         <i className="material-icons" style={{ transform: "rotate(90deg)" }}>
//           remove
//         </i>
//       </HalfButton>
      
//       <HalfButton
//         style={{
//           position: "absolute",
//           left: "24px",
//           top: "290px",
//           transform: "rotate(90deg)"
//         }}
//         theme={theme}
//       >
//         <i className="material-icons">add</i>
//       </HalfButton>


// WEBPACK FOOTER //
// ./src/containers/editorToolBar/EditorToolbar.js